export default __webpack_public_path__ + "static/media/315-deg.120c95ce.svg";